import { NoDataMessage } from "../../../../BuildingBlocks/NoDataMessage/NoDataMessage";
import type { AcquisitionWithSummaryData } from "../../EnergyDataAcquisitionList/EnergyDataAcquisitionList";
import { EnergyDataAcquisitionList } from "../../EnergyDataAcquisitionList/EnergyDataAcquisitionList";
import type { Acquisition } from "../../EnergyDataView";

interface AcquisitionListProps {
  acquisitions: Array<Acquisition>;
  selection?: Array<AcquisitionWithSummaryData["id"]>;
  onSelect?: (selection: Array<AcquisitionWithSummaryData["id"]>) => void;
}

function AcquisitionList({
  acquisitions,
  selection,
  onSelect
}: AcquisitionListProps) {
  const totalAcquisitions = acquisitions.length;

  return (
    <div className="acquisition-list">
      <EnergyDataAcquisitionList
        acquisitions={acquisitions}
        selection={selection}
        showAll
        onSelect={(s) => onSelect?.(s)}
      />
      {totalAcquisitions === 0 && (
        <NoDataMessage
          message="Für die ausgewählten Filter stehen keine Energiedaten zur Verfügung"
          p="sm"
        />
      )}
    </div>
  );
}

export { AcquisitionList };
